var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-staff.9005ebcf.png","uri@2x": __webpack_public_path__ + "icon-staff.d946e053.png","uri@3x": __webpack_public_path__ + "icon-staff.f2bfe306.png",
    width: 20,
    height: 20
});